/**
 * Flow Automation Storage Router
 * When USE_GOBODO_API is true, delegates to Gobodo; otherwise uses flowAutomationStorage (localStorage).
 */

import type { Flow, FlowStats, CreateFlowPayload, UpdateFlowPayload, CloneFlowPayload } from '../types/flowAutomation';
import { USE_GOBODO_API } from '../utils/gobodoUtils';
import { flowAutomationStorage } from './flowAutomationStorage';
import * as gobodoService from './gobodo/gobodoFlowService';

export async function getAllFlowsAsync(): Promise<Flow[]> {
  if (USE_GOBODO_API) return gobodoService.getFlows();
  return Promise.resolve(flowAutomationStorage.getAllFlows());
}

export async function getFlowAsync(flowId: string): Promise<Flow | null> {
  if (USE_GOBODO_API) return gobodoService.getFlowById(flowId);
  return Promise.resolve(flowAutomationStorage.getFlow(flowId));
}

export async function getStatsAsync(): Promise<FlowStats> {
  if (USE_GOBODO_API) return gobodoService.getStats();
  return Promise.resolve(flowAutomationStorage.getStats());
}

export async function createFlowAsync(payload: CreateFlowPayload): Promise<Flow> {
  if (USE_GOBODO_API) return gobodoService.createFlow(payload);
  return Promise.resolve(flowAutomationStorage.createFlow(payload));
}

export async function updateFlowAsync(payload: UpdateFlowPayload): Promise<Flow | null> {
  if (USE_GOBODO_API) return gobodoService.updateFlow(payload);
  return Promise.resolve(flowAutomationStorage.updateFlow(payload));
}

export async function deleteFlowAsync(flowId: string): Promise<boolean> {
  if (USE_GOBODO_API) return gobodoService.deleteFlow(flowId);
  return Promise.resolve(flowAutomationStorage.deleteFlow(flowId));
}

export async function cloneFlowAsync(payload: CloneFlowPayload): Promise<Flow | null> {
  if (USE_GOBODO_API) return gobodoService.cloneFlow(payload);
  return Promise.resolve(flowAutomationStorage.cloneFlow(payload));
}

export async function activateFlowAsync(flowId: string): Promise<Flow | null> {
  if (USE_GOBODO_API) return gobodoService.activateFlow(flowId);
  return Promise.resolve(flowAutomationStorage.activateFlow(flowId));
}

export async function deactivateFlowAsync(flowId: string): Promise<Flow | null> {
  if (USE_GOBODO_API) return gobodoService.deactivateFlow(flowId);
  return Promise.resolve(flowAutomationStorage.deactivateFlow(flowId));
}
